import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_BU_TYPES);
var axios_instance_upload_template = get_axios_instance(api_variables.SERVICE_BUSSINESS_UNIT_TYPES_UPLOAD_TEMPLATE);

const _pk_name = "id";

const state = {
    data: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};

const getters = {
    getbuTypes: (state) => {
        if (state.data) {
            return state.data
        } else {
            this.fetchAll()
        }
    },
    editMode: (state) => {
        return state.editMode
    },
    record: (state) => {
        return state.record
    }
}

const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    addEntity: (state, payload) => {
        state.data.data.push(payload);
    },

    updateEntityById: (state, payload) => {
        for (let i = 0; i < state.data.length; i++) {
            if (state.data[i][_pk_name] === payload.id) {
                state.data.splice(i, 1, payload);
            }
        }
    },

    removeEntityById: (state, payload) => {
        for (let i = 0; i < state.data.data.length; i++) {
            if (state.data.data[i][_pk_name] == payload) {
                state.data.data.splice(i, 1);
            }
        }
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },

    setEditMode: (state, payload) => {
        state.editMode = payload.editMode;
        state.record = payload.record;
    }
}

const updateToken = () => {
    let token = localStorage.getItem('token') ? localStorage.getItem('token').replace(/(^"|"$)/g, '') : "";
    axios_instance.defaults.headers['Authorization'] = `Bearer ${token}`;
}

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            updateToken();
            // to make call only when payload is available -291/11/2019
            if (payload) {
                commit("setFetching", true);
                let res = await axios_instance.get(``, {
                    params: {
                        org_id: payload
                    }
                });
                commit("setFetching", false);
                if (res.data.status) {
                    commit("set", res.data.payload); //todo: Check for Pagination
                }
                return res;
            }
        } catch (error) {
            commit("set", []);
            throw errorHandler(error.response);
        }
    },

    async uploadTemplate({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance_upload_template.post(``, payload);
            commit("setFetching", false);
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post('/', payload);
            commit("setSaving", false);
            if (res.status == 200 || res.status == 201) {
                commit("addEntity", res.data.payload);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.put('/' + payload.data.id, payload);
            commit("setSaving", false);
            if (res.status == 200) {
                commit("updateEntityById", res.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async delete({ commit }, payload) {
        try {
            commit("setDeleting", true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit("setDeleting", false);
            if (res.status == 200) {
                commit("removeEntityById", payload.id);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async changeEditMode({ commit }, payload) {
        try {
            commit("setEditMode", payload);
        } catch (error) {
            throw errorHandler(error.response ? error.response : error.message);
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}